var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100 position-absolute vh-100 d-flex justify-content-center align-items-center",staticStyle:{"top":"0"}},[_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("Spiacenti, questa pagina non esiste :(")]),_c('router-link',{attrs:{"to":{name: 'Start'}}},[_vm._v("torna alla home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }